function getSafeImageSource<T>(image: T): string {
  if (!image) return ''
  if (typeof image === 'string') return image
  return (image as unknown as { src: string }).src
}

export default getSafeImageSource
